<div [formGroup]="mainForm" *ngIf="initialized">
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form-select" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>支払方法</mat-label>
        <mat-select
          formControlName="selectedPayMethod"
          (selectionChange)="onChangePayMethod()"
        >
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of codePayMethodList"
            [value]="code.value"
          >{{ code.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <app-sgkd002d-kouza
      [mainForm]="mainForm"
      [codeDptClsfyCdList]="codeDptClsfyCdList"
      [codeRecivMethodList]="codeRecivMethodList"
      [businessDate]="businessDate"
      (clearMessageEvent)="clearMessage()"
      *ngIf="isKouza(mainForm.controls['selectedPayMethod'].value)"/>
    <app-sgkd002d-crd
      [mainForm]="mainForm"
      [codeCreComAnameList]="codeCreComAnameList"
      *ngIf="isCrd(mainForm.controls['selectedPayMethod'].value)"/>
    <app-sgkd002d-sms
      [mainForm]="mainForm"
      *ngIf="isSms(mainForm.controls['selectedPayMethod'].value)"/>
  </div>